import { Link } from 'react-router-dom';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const features = [
  {
    icon: 'ri-shield-check-line',
    title: 'Seguridad Certificada',
    desc: 'Ganadores del Premio SERNAGEOMIN 2008 por cero accidentes en minería. La seguridad es nuestra prioridad.',
  },
  {
    icon: 'ri-medal-line',
    title: '+25 Años de Experiencia',
    desc: 'Más de dos décadas ejecutando proyectos de construcción en todo Chile con excelencia y profesionalismo.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Amplia Cobertura',
    desc: 'Operamos en Temuco, Padre Las Casas, Villarrica, Pucón, Concepción, Puerto Montt, Coyhaique y más ciudades de Chile.',
  },
  {
    icon: 'ri-time-line',
    title: 'Cumplimiento de Plazos',
    desc: 'Nos comprometemos con los tiempos acordados. Nuestros clientes valoran nuestra puntualidad y responsabilidad.',
  },
  {
    icon: 'ri-star-line',
    title: '4.5 Estrellas en Google',
    desc: 'Calificación destacada por nuestros clientes. "Excelente servicio", "Responsables", "Trabajo de calidad".',
  },
  {
    icon: 'ri-team-line',
    title: 'Equipo Profesional',
    desc: 'Ingenieros, técnicos y operarios altamente capacitados para entregar proyectos de la más alta calidad.',
  },
];

const WhyUs = () => {
  const { ref: leftRef, isVisible: leftVisible } = useScrollAnimation();
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left */}
          <div
            ref={leftRef}
            className={`reveal-left ${leftVisible ? 'reveal-visible' : ''}`}
          >
            <span className="text-[#C88A2A] text-sm font-bold uppercase tracking-widest">¿Por qué elegirnos?</span>
            <h2 className="text-3xl md:text-4xl font-black text-[#0C1D2E] mt-2 mb-4 leading-tight">
              Construimos con calidad,<br />
              <span className="text-[#C88A2A]">seguridad y compromiso</span>
            </h2>
            <p className="text-[#475569] text-base leading-relaxed mb-8">
              IngemetalSur es una empresa constructora en Temuco reconocida por su trayectoria, profesionalismo y los resultados que entregamos en cada proyecto de obras civiles y galpones industriales en Chile.
            </p>

            <Link
              to="/nosotros#premio-sernageomin"
              className="flex items-center gap-6 p-5 bg-[#F8FAFC] rounded-lg hover:bg-[#E2E8F0] hover:-translate-y-0.5 transition-all duration-200 cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-yellow-400 rounded-full shrink-0">
                <i className="ri-award-fill text-white text-2xl"></i>
              </div>
              <div>
                <div className="font-bold text-[#0C1D2E] text-base">Premio SERNAGEOMIN 2008</div>
                <div className="text-[#475569] text-sm mt-1">Reconocimiento por seguridad minera y cero accidentes. Un logro que nos enorgullece.</div>
              </div>
            </Link>
          </div>

          {/* Right: Grid */}
          <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {features.map((f, i) => (
              <div
                key={f.title}
                className={`flex items-start gap-4 p-5 rounded-lg bg-[#F8FAFC] hover:bg-[#E2E8F0] hover:-translate-y-0.5 transition-all duration-200 reveal ${gridVisible ? 'reveal-visible' : ''} reveal-delay-${(i + 1) * 100}`}
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#1A3A5C] rounded-md shrink-0">
                  <i className={`${f.icon} text-white text-lg`}></i>
                </div>
                <div>
                  <div className="font-bold text-[#0C1D2E] text-sm mb-1">{f.title}</div>
                  <div className="text-[#475569] text-xs leading-relaxed">{f.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;